import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';

const data = [
  {
    link: 'https://github.com/gavinjyhuang/',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/gavin.huang.7564',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/huangavin_/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/gavinjhuang',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:gavinhuang2004@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
